import PageInfo from '@components/PaginationLayout/PageInfo'
import Pagination from '@components/PaginationLayout/Pagination'
import SelectPage from '@components/PaginationLayout/SelectPage'

export type paginationType = {
  current_page: number
  per_page: number
  total: number
  total_pages: number
  hide?: boolean
  hideTopNavigation?: boolean
}

type propTypes = paginationType & {
  pageChange: any
  children: any
}

const PaginationLayout = ({
  current_page,
  per_page,
  total,
  total_pages,
  pageChange,
  hide = total <= 0,
  hideTopNavigation = false,
  children,
}: propTypes) => {
  if (hide || current_page > total_pages)
    return <div className={'my-2'}>{children}</div>

  const onPageChange = (pageNumber: number) => {
    pageChange(pageNumber)
    window.scrollTo(0, 0)
  }

  return (
    <div className={'w-full flex flex-col items-center gap-1'}>
      {hideTopNavigation ? (
        <></>
      ) : (
        <>
          <PageInfo page={current_page} perPage={per_page} itemTotal={total} />
          <Pagination
            page={current_page}
            totalPages={total_pages}
            pageChange={onPageChange}
          />
          <SelectPage
            page={current_page}
            totalPages={total_pages}
            pageChange={pageChange}
          />
        </>
      )}

      <div className={`${hideTopNavigation ? 'mb-2' : 'my-2'} w-full`}>
        {children}
      </div>
      <SelectPage
        page={current_page}
        totalPages={total_pages}
        pageChange={pageChange}
      />
      <Pagination
        page={current_page}
        totalPages={total_pages}
        pageChange={onPageChange}
      />
      <PageInfo page={current_page} perPage={per_page} itemTotal={total} />
    </div>
  )
}
export default PaginationLayout
